<template>
	<div>
		<!-- begin breadcrumb -->
		<ol class="breadcrumb float-xl-right">
			<li class="breadcrumb-item active"><a href="javascript:;">Pago a Personal Responsable</a></li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Pago a Personal Responsable </h1>
		<!-- end page-header -->
		<!-- begin panel -->
		<!-- <panel title="Panel Title here">
			Panel Content Here
		</panel> -->
		<!-- end panel -->
		<!-- begin card -->
		<div class="card  border-0 ">
			<div class="card-body table-responsive">

				<div class="row ">
					<div class="col-lg-2">
						<select class="form-control" v-model="mes" name="" id="">
							<option value="">Seleccione Mes</option>
							<option value="1">Enero</option>
							<option value="2">Febrero</option>
							<option value="3">Marzo</option>
							<option value="4">Abril</option>
							<option value="5">Mayo</option>
							<option value="6">Junio</option>
							<option value="7">Julio</option>
							<option value="8">Agosto</option>
							<option value="9">Setiembre</option>
							<option value="10">Octubre</option>
							<option value="11">Noviembre</option>
							<option value="12">Diciembre</option>
						</select>
					</div>
					<div class="col-lg-2">
						<input type="text" v-model="anio" class="form-control font-weight-bold" maxlength="4"
							placeholder="Ingrese año">
					</div>

					<div class="col-lg-2">
						<button v-if="$store.state.usuario.tipo==2" type="button" @click="buscar()" class="btn btn-info"> <i class="fa fa-search"></i>
							Buscar</button>
					
					</div>
					<div class="col-lg-2">
						<export-excel v-show="reportes.length>0" :footer="'TOTAL REGISTRADOS: '+reportes.length"
							:title="'::..REPORTE DE PAGO A PERSONAL RESPONSABLE - SISTEMA TELEMARTIN '+mes+'/'+anio+'..::'"
							class="btn btn-success btn-sm btn-block" :data="reportes" :fields="json_fields"
							worksheet="pago" name="pago_personal_responsable.xls">
							<i class="fa fa-download"></i> Excel
						</export-excel>
					</div>

				</div>

			</div>
		</div>
		<!-- begin row -->
		<div class="row animated fadeIn" v-if="nuevoComisionChip==0">
			<!-- begin col-12 -->
			<div class="col-xl-12 card card-body table-responsive">
				<table class="table table-sm table-hover">
					<tr class="h3 bg-yellow">
						<th>Departamento</th>
						<th>Tipo </th>
						<th>DNI</th>
						<th>Responsable</th>
						<th>Comisión n° vendedores</th>
						<th>Total C. x vendedores</th>
						
						<th>Total </th>
					
						<th>Boleta</th>
					</tr>
					<tr v-for="r in reportes" :key="r.dni">
						<td class="h4">{{r.departamento}}</td>
						<td class="h4">{{r.tipo}}</td>
						<td class="h4" v-show="$store.state.usuario.tipo==2" >{{r.dni}}</td>
						<td class="h4">{{r.responsable}}</td>
						<td class="h4">{{r.comision_nro_vendedores}}</td>
						<td class="h4">{{r.suma_com_vendedores}}</td>
						<td class="h4">{{r.total_cobrar}}</td>
						
						<td>
							
							 <a v-b-modal.modalBoleta href="javascript:;"
								@click="imprimirBoleta(r.comision_nro_vendedores, r.suma_com_vendedores, r.total_cobrar, r.mes,r.responsable)"
								class="btn btn-dark btn-sm btn-block"> <i class="fa fa-file"></i> </a>
								</td>

					</tr>
					
				</table>
				<procesando v-if="proceso" />
			</div>
			<!-- end col-12 -->
		</div>
		<!-- end row -->
		<!-- begin row -->

		<!-- end row -->

	</div>
</template>
<script>
	import Vue from "vue";
	import excel from "vue-excel-export";
	import procesando from '../components/compartidos/Procesando'
	Vue.use(excel);
	import axios from 'axios'
	export default {
		name: "PagoPersonalResposanble",
		components: {
			procesando
		},
		created() {
			// this.loadItems() ;
		},
		data() {
			return {
				json_fields: {
					"Tipo Vendedor": "tipo",
					Responsable: "responsable",
					Departamento: "departamento",
					
					DNI: {
						field: "dni",
						callback: value => {
							return `DNI - ${value}`;
						}
					},
					"Total": "total_cobrar",
				},
				anio: "",
				mes: "",
				proceso: false,
				nuevo: true,
				comisionChip: null,
				nuevoComisionChip: 0,
				counter: 0,
				reportes: [],
				boleta: {
					dni: '',
					personal: '',
					mes: '',
					tipo_vendedor: ''
				},
				escolaridad: "",
				fiestas_patrias: "",
				navidad: "",
				montos_anteriores: [],
				totalRecords: 0,
				serverParams: {
					search: '',
					sort: {
						field: 'id',
						type: 'asc',
					},
					page: 1,
					perPage: 10
				},
				
				comisionPorNroVendedores:0,

			}
		},
		methods: {
			
			buscar() {
				this.reportes = [],
					this.proceso = true;
				axios.post(this.URL_BASE() + "personal/reporte_pago_responsable_admin/" + this.anio + "/" + this.mes, ).then(respuesta => {
					//   console.log(respuesta.data.msg)
					if (respuesta.data.msg == 'exito') {
						this.reportes = respuesta.data.data

					}
					this.proceso = false;
				}).catch( (error)=> {
					console.log("er store" + error);
				});
			},
			
		
			imprimirBoleta(comision_nro_vendedores, suma_com_vendedores, pagoTotal, mes,nombrePersonal) {


				let nombreCompletoPersonal;
				if(this.$store.state.usuario.tipo==3 || this.$store.state.usuario.tipo==4 || this.$store.state.usuario.tipo==2){
					nombreCompletoPersonal=nombrePersonal;
				}else{
					nombreCompletoPersonal=this.$store.state.usuario.nombres + ' ' + this.$store.state
					.usuario.appa + ' ' + this.$store.state.usuario.apma ;
				}
				var mywindow = window.open('', 'Boleta', "scrollbars=yes, titlebar=yes");
				// var mywindow = window.open('', '_self').close();
				mywindow.document.write('<html><head>');
				mywindow.document.write(
					'<style>.tabla{width:100%;border-collapse:collapse;margin:16px 0 16px 0;}.tabla th{border:1px solid #ddd;padding:4px;background-color:#d4eefd;text-align:left;font-size:15px;}.tabla td{border:1px solid #ddd;text-align:left;padding:6px;}</style>'
					);
				mywindow.document.write('</head><body >');
				mywindow.document.write('<table class="tabla">');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td style="width:50%">');
				mywindow.document.write('<img src="https://telemartin.com/app/assets/logo.png">');
				mywindow.document.write('</td>');
				mywindow.document.write('<td style="width:50%;text-align:right">');
				mywindow.document.write('<h1>Telemartin</h1>');
				mywindow.document.write('<h3><i>Creciendo sin límites</i></h3>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th colspan="2">');
				mywindow.document.write('PAGO DEL MES: ' + this.mesesNumerosToLetras(mes));
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th colspan="2">');
				mywindow.document.write('PERSONAL: <b>' + nombreCompletoPersonal + '</b>');
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td colspan="2">');
				mywindow.document.write('<B>A PAGAR:</B>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------COMISIÓN POR N° DE VENDEDORES');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write(comision_nro_vendedores);
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				
				mywindow.document.write('<tr>');
				mywindow.document.write('<td colspan="2">');
				mywindow.document.write('<B>ADELANTOS:</B>');
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<td>');
				mywindow.document.write('--------10% COMISIÓN DEL TOTAL DE VENTAS');
				mywindow.document.write('</td>');
				mywindow.document.write('<td>');
				mywindow.document.write((suma_com_vendedores*0.1).toFixed(2));
				mywindow.document.write('</td>');
				mywindow.document.write('</tr>');
				mywindow.document.write('<tr>');
				mywindow.document.write('<th>');
				mywindow.document.write('TOTAL A PAGAR EN EL MES DE: ' + this.mesesNumerosToLetras(mes));
				mywindow.document.write('</th>');
				mywindow.document.write('<th>');
				mywindow.document.write("<h4>S/." + pagoTotal + "</h4>");
				mywindow.document.write('</th>');
				mywindow.document.write('</tr>');


				// mywindow.document.write(document.getElementById('muestra').innerHTML);
				mywindow.document.write('</table>');
				mywindow.document.write('</body></html>');
				mywindow.document.close(); // necesario para IE >= 10
				mywindow.focus(); // necesario para IE >= 10
				mywindow.print();
				// mywindow.close();
				return true;
			},
			

		},
		computed: {
			total() {
				return this.reportes.reduce((total, item) => {
					return total + Number(item.total);
				}, 0.00);
			},
			
		},
	}
</script>